module.exports = __webpack_public_path__ + "img/eduzz.02ab30b6.png";